export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': 'Aplicación',
            'horizontal': 'Horizontal',
            'horizontalMenu': 'Menú horizontal',
            'general': 'General',
            'component': 'Componente',
            'features': 'Caracteristicas',
            'applications': 'Aplicaciones',
            'dashboard': 'tablero',
            'dashboard1': 'Tablero de instrumentos 1',
            'dashboard2': 'Tablero 2',
            'dashboard3': 'Tablero 3',
            'modules': 'Módulos',
            'agency': 'Agencia',
            'pages': 'Páginas',
            'gallery': 'Galería',
            'pricing': 'Precios',
            'terms&Conditions': 'Términos y condiciones',
            'feedback': 'Realimentación',
            'report': 'Informe',
            'faq(s)': 'Faq(s)',
            'advancedComponent': 'Componente avanzado',
            'blank': 'Blanco',
            'session': 'Sesión',
            'login': 'Iniciar sesión',
            'register': 'Registro',
            'lockScreen': 'Bloquear pantalla',
            'forgotPassword': 'Olvidé mi contraseña',
            'uiComponents': 'Componentes de interfaz de usuario',
            'alerts': 'Alertas',
            'appBar': 'Barra de aplicaciones',
            'avatars': 'Avatares',
            'buttons': 'Botones',
            'bottomNavigations': 'Navegaciones inferiores',
            'badges': 'Insignias',
            'cards': 'Tarjetas',
            'cardsMasonry': 'Tarjetas Masonary',
            'chip': 'Chip',
            'dialog': 'Diálogo',
            'dividers': 'Divisores',
            'drawers': 'Cajones',
            'popover': 'Popover',
            'expansionPanel': 'Panel de Expansión',
            'gridList': 'Lista de cuadrícula',
            'list': 'Lista',
            'menu': 'Menú',
            'popoverAndToolTip': 'Popover & Consejo de herramienta',
            'progress': 'Progreso',
            'snackbar': 'Snackbar',
            'selectionControls': 'Controles de selección',
            'advanceUiComponents': 'Componentes avanzados de UI',
            'dateAndTimePicker': 'Selector de fecha y hora',
            'tabs': 'Pestañas',
            'stepper': 'Paso a paso',
            'notification': 'Notificación',
            'sweetAlert': 'Dulce Alerta',
            'autoComplete': 'Auto completo',
            'aboutUs': 'Sobre nosotros',
            'widgets': 'Widgets',
            'forms': 'Formularios',
            'formElements': 'Elementos de forma',
            'textField': 'Campo de texto',
            'selectList': 'Seleccionar lista',
            'charts': 'Gráficos',
            'reCharts': 'Re Gráficos',
            'reactChartjs2': 'Reaccionar Chartjs 2',
            'icons': 'Iconos',
            'themifyIcons': 'Themify Iconos',
            'simpleLineIcons': 'Iconos de línea sencillo',
            'materialIcons': 'Iconos de material',
            'fontAwesome': 'Fuente impresionante',
            'tables': 'Mesas',
            'basic': 'BASIC',
            'dataTable': 'Tabla de datos',
            'responsive': 'Sensible',
            'reactTable': 'Reaccionar',
            'maps': ' Mapas',
            'googleMaps': 'mapas de Google',
            'leafletMaps': 'Mapas de folletos',
            'inbox': 'Bandeja de entrada',
            'users': 'Usuarios',
            'userProfile1': 'Perfil de usuario 1',
            'userProfile2': 'Perfil de usuario 2',
            'userManagement': 'Gestión de usuarios',
            'userProfile': 'Perfil del usuario',
            'userList': 'Lista de usuarios',
            'calendar': 'Calendario',
            'cultures': 'Culturas',
            'dnd': 'Dnd',
            'selectable': 'Seleccionable',
            'customRendering': 'Representación personalizada',
            'chat': 'Charla',
            'toDo': 'Que hacer',
            'editor': 'Editor',
            'wysiwygEditor': 'Editor WYSIWYGWYSIWYG Editor',
            'quillEditor': 'Pluma Editor',
            'reactAce': 'Reaccionar Ace',
            'dragAndDrop': 'Arrastrar y soltar',
            'reactDragula': 'Reaccionar  Dragula',
            'reactDnd': 'Reaccionar Dnd',
            'blogManagement': 'Gestión de Blog',
            'ecommerce': 'Comercio electrónico',
            'shopList': 'Lista de compras',
            'shopGrid': 'Comprar cuadrícula',
            'invoice': 'Factura',
            'multilevel': 'Multinivel',
            'sublevel': 'Subnivel',
            'dateTimePicker': 'Selector de fecha y hora',
            'user': 'Usuario',
            'miscellaneous': 'Diverso',
            'promo': 'Promoción',
            'gettingStarted': 'Empezando',
            'shop': 'tienda',
            'cart': 'Carro',
            'checkout': 'Revisa',
            'saas': 'SAAS',
            'multiLevel': 'Multi nivel',
            'level1': 'Nivel 1',
            'level2': 'Nivel 2',
            'boxed': 'En caja',
            'news': 'Noticias',
            'extensions': 'Extensiones',
            'imageCropper': 'Imagen Cropper',
            'videoPlayer': 'Reproductor de video',
            'dropzone': 'Zona de descenso',
            'crm': 'CRM',
            'projects': 'proyectos',
            'projectDetail': 'detalle del proyecto',
            'clients': 'clientela',
            'reports': 'informes'
        },
        'widgets': {
            'totalEarns': 'Total gana',
            'emailsStatistics': 'Estadísticas de correos electrónicos',
            'totalRevenue': 'Los ingresos totales',
            'onlineVistors': 'Votos en línea',
            'trafficSources': 'Fuentes de tráfico',
            'RecentOrders': 'órdenes recientes',
            'topSellings': 'Mejores ventas',
            'productReports': 'Informes de productos',
            'productStats': 'Estadísticas del producto',
            'ComposeEmail': 'Escribir correo',
            'employeePayroll': 'Nómina de empleados',
            'visitors': 'Visitantes',
            'orders': 'Pedidos',
            'orderStatus': 'Estado del pedido',
            'totalSales': 'Ventas totales',
            'netProfit': 'Beneficio neto',
            'overallTrafficStatus': 'Estado general del tráfico',
            'tax': 'Impuesto',
            'expenses': 'Gastos',
            'currentTime': 'Tiempo actual',
            'ratings': 'Calificaciones',
            'currentDate': 'Fecha actual',
            'todayOrders': 'Pedidos de hoy',
            'toDoList': 'Para hacer listas',
            'discoverPeople': 'Descubre personas',
            'commments': 'Comentarios',
            'newCustomers': 'nuevos clientes',
            'recentNotifications': 'Notificaciones recientes',
            'appNotifications': 'Notificaciones de aplicación',
            'newEmails': 'Nuevos correos electrónicos',
            'siteVisitors': 'Visitantes del sitio',
            'recentActivities': 'Actividades recientes',
            'recentOrders': 'órdenes recientes',
            'gallery': 'Galería',
            'pricing': 'Precios',
            'enterpriseEdition': 'Edición de Empresa',
            'personalEdition': 'Edición personal',
            'socialCompanines': 'Empresas sociales',
            'teamEdition': 'Edición de equipo',
            'standard': 'Estándar',
            'advanced': 'Avanzado',
            'master': 'MasterDominar',
            'Mega': 'MegaMega',
            'logIn': 'Iniciar sesión',
            'signUp': 'Regístrate',
            'lockScreen': 'Bloquear pantalla',
            'alertsWithLink': 'Alertas con enlace',
            'additionalContent': 'Contenido adicional',
            'alertDismiss': 'Alerta de descartar',
            'uncontrolledDisableAlerts': 'Alertas de Deshabilitar descontrolado',
            'contexualAlerts': 'Alertas Contexuales',
            'alertsWithIcons': 'Alertas con iconos',
            'Simple App Bars': 'Barras de aplicación simples',
            'appBarsWithButtons': 'Barras de aplicación con botones',
            'imageAvatars': 'Avatares de imagen',
            'lettersAvatars': 'Cartas Avatares',
            'iconsAvatars': 'Iconos Avatares',
            'flatButtons': 'Botones planos',
            'raisedButton': 'Botón elevado',
            'buttonWithIconAndLabel': 'Botón con icono y etiqueta',
            'floatingActionButtons': 'Botones de acción flotante',
            'iconButton': 'Botón de icono',
            'socialMediaButton': 'Botón de redes sociales',
            'reactButton': 'React Button',
            'buttonOutline': 'Contorno del botón',
            'buttonSize': 'Tamaño del botón',
            'buttonState': 'Estado del botón',
            'buttonNavigationWithNoLabel': 'botón Navegación sin etiqueta',
            'buttonNavigation': 'Navegación de botón',
            'iconNavigation': 'Navegación de iconos',
            'badgeWithHeadings': 'Insignia con títulos',
            'contexualVariations': 'Variaciones Contexuales',
            'badgeLinks': 'Enlaces de placa',
            'materialBadge': 'Insignia de material',
            'simpleCards': 'Tarjetas simples',
            'backgroundVarient': 'Variente de fondo',
            'cardOutline': 'Esquema de la tarjeta',
            'overlayCard': 'Tarjeta de superposición',
            'cardGroup': 'Grupo de tarjetas',
            'cardTitle': 'Título de la tarjeta',
            'speacialTitleTreatment': 'Tratamiento de título especial',
            'chipWithClickEvent': 'Chip con evento Click',
            'chipArray': 'Chip Array',
            'dialogs': 'Diálogos',
            'listDividers': 'List Dividers',
            'insetDividers': 'Divisores de inserción',
            'temporaryDrawers': 'Cajones temporales',
            'permanentDrawers': 'Cajones permanentes',
            'simpleExpansionPanel': 'Panel de expansión simple',
            'controlledAccordion': 'Acordeón controlado',
            'secondaryHeadingAndColumns': 'Encabezado secundario y columnas',
            'imageOnlyGridLists': 'Las listas de cuadrícula solo con imágenes',
            'advancedGridLists': 'Listas de grillas avanzadas',
            'singleLineGridLists': 'Listas de cuadrículas unifilares',
            'simpleLists': 'Listas simples',
            'folderLists': 'Listas de carpetas',
            'listItemWithImage': 'Artículo de lista con imagen',
            'switchLists': 'Cambiar listas',
            'insetLists': 'Listas de inserción',
            'nestedLists': 'Listas anidadas',
            'checkboxListControl': 'Control de lista de casillas de verificación',
            'pinedSubHeader': 'Sub encabezado pined',
            'InteractiveLists': 'Listas interactivas',
            'simpleMenus': 'Menús simples',
            'selectedMenu': 'Menú Seleccionado',
            'maxHeightMenu': 'Menú de altura máxima',
            'changeTransition': 'Cambiar la transición',
            'paper': 'Papel',
            'anchorPlayGround': 'ancla Patio de recreo',
            'tooltip': 'Información sobre herramientas',
            'positionedToolTips': 'Barra de Snack Posicionado',
            'circularProgressBottomStart': 'Inicio inferior de progreso circular',
            'interactiveIntegration': 'Integración Interactiva',
            'determinate': 'Determinado',
            'linearProgressLineBar': 'Lineal Progreso Línea Bar',
            'indeterminate': 'Indeterminado',
            'buffer': 'Buffer',
            'query': 'Consulta',
            'transitionControlDirection': 'Dirección de control de transición',
            'simpleSnackbar': 'Snackbar simple',
            'positionedSnackbar': 'Barra de Snack Posicionado',
            'contexualColoredSnackbars': 'Snackbars de colores contextuales',
            'simpleCheckbox': 'Casilla de verificación simple',
            'interminateSelection': 'Selección Interminada',
            'disabledCheckbox': 'Casilla de verificación desactivada',
            'customColorCheckbox': 'Casilla de verificación de color personalizado',
            'VerticalStyleCheckbox': 'Casilla de verificación de estilo vertical',
            'horizontalStyleCheckbox': 'Casilla de verificación de estilo horizontal',
            'radioButtons': 'Botones de radio',
            'disabledRadio': 'Radio inhabilitada',
            'withError': 'Con error',
            'switches': 'Swiches',
            'dateAndTimePicker': 'Selector de fecha y hora',
            'defaultPicker': 'Selector predeterminado',
            'timePicker': 'Selector de tiempo',
            'weekPicker': 'Selector de semana',
            'defaultDatePicker': 'Selector de fecha predeterminado',
            'customPicker': 'Selector personalizado',
            'tabs': 'Pestañas',
            'fixedTabs': 'Pestañas fijas',
            'basicTab': 'Pestaña básica',
            'wrappedLabels': 'Etiquetas envueltas',
            'centeredLabels': 'Etiquetas centradas',
            'forcedScrolledButtons': 'Botones desplazados forzados',
            'iconsTabs': 'Pestañas de iconos',
            'withDisableTabs': 'Con Inhabilitar Pestañas',
            'iconWithLabel': 'Icono con etiqueta',
            'stepper': 'Paso a paso',
            'horizontalLinear': 'Horizontal lineal',
            'horizontalNonLinear': 'Horizontal no lineal',
            'horizontalLinerAlternativeLabel': 'Etiqueta alternativa horizontal del trazador de líneas',
            'horizontalNonLinerAlternativeLabel': 'Etiqueta alternativa horizontal sin revestimiento',
            'verticalStepper': 'Stepper vertical',
            'descriptionAlert': 'Descripción Alerta',
            'customIconAlert': 'Alerta de icono personalizado',
            'withHtmlAlert': 'Con Html Alert',
            'promptAlert': 'Aviso rápido',
            'passwordPromptAlert': 'Alerta de solicitud de contraseña',
            'customStyleAlert': 'Alerta de estilo personalizado',
            'autoComplete': 'Auto completo',
            'reactSelect': 'React Select',
            'downshiftAutoComplete': 'Cambio descendente Auto Completar',
            'reactAutoSuggests': 'Reaccionar Auto Sugiere',
            'aboutUs': 'Sobre nosotros',
            'ourVission': 'Nuestra Vision',
            'ourMissions': 'Nuestras Misiones',
            'ourMotivation': 'Nuestra motivación',
            'defualtReactForm': 'Formulario de declaración de defualt',
            'url': 'Url',
            'textArea': 'Área de texto',
            'file': 'Archivo',
            'formGrid': 'Formulario Cuadrícula',
            'inlineForm': 'Formulario en línea',
            'inputSizing': 'Tamaño de entrada',
            'inputGridSizing': 'Tamaño de cuadrícula de entrada',
            'hiddenLabels': 'Etiquetas escondidas',
            'formValidation': 'Formar Validación',
            'number': 'Número',
            'date': 'Fecha',
            'time': 'Hora',
            'color': 'Color',
            'search': 'Buscar',
            'selectMultiple': 'Seleccionar múltiples',
            'inputWithSuccess': 'Entrada con éxito',
            'inputWithDanger': 'Entrada con peligro',
            'simpleTextField': 'Campo de texto simple',
            'componet': 'Componentes',
            'layouts': 'Diseños',
            'inputAdorements': 'Adoración de entrada',
            'formattedInputs': 'Entradas formateadas',
            'simpleSelect': 'Simple Select',
            'nativeSelect': 'Selección nativa',
            'MutltiSelectList': 'Lista de selección Mutlti',
            'lineChart': 'Gráfico de linea',
            'barChart': 'Gráfico de barras',
            'stackedBarChart': 'Gráfico de barras apiladas',
            'lineBarAreaChart': 'Gráfico de área de la barra de líneas',
            'areaChart': 'Carta de área',
            'stackedAreaChart': 'Tabla de áreas apiladas',
            'verticalChart': 'Gráfico vertical',
            'radarChart': 'Gráfico de radar',
            'doughnut': 'Rosquilla',
            'polarChart': 'Gráfico polar',
            'pieChart': 'Gráfico circular',
            'bubbleChart': 'Bubble Gráfico',
            'horizontalBar': 'Barra Horizonatl',
            'basicTable': 'Tabla básica',
            'contexualColoredTable': 'Tabla de colores Contexual',
            'dataTable': 'Tabla de datos',
            'employeeList': 'Lista de empleados',
            'responsiveTable': 'Tabla receptiva',
            'responsiveFlipTable': 'Mesa giratoria receptiva',
            'reactGridControlledStateMode': 'Reaccionar Cuadrícula Revisado Estado Modo',
            'googleMaps': 'mapas de Google',
            'productsReports': 'Informes de productos',
            'taskList': 'Lista de tareas',
            'basicCalender': 'Calendario básico',
            'culturesCalender': 'Calendario de las culturas',
            'dragAndDropCalender': 'Calendario de arrastrar y soltar',
            'selectableCalender': 'Calendario seleccionable',
            'customRendering': 'Representación personalizada',
            'customCalender': 'Calendario personalizado',
            'searchMailList': 'Buscar lista de correo',
            'forgetPassword': 'Contraseña olvidada',
            'QuickLinks': 'enlaces rápidos',
            'upgrade': 'mejorar',
            'app': 'Aplicación',
            'addNew': 'Agregar nuevo',
            'orderDate': 'Fecha de orden',
            'status': 'Estado',
            'trackingNumber': 'El número de rastreo',
            'action': 'Acción',
            'designation': 'Designacion',
            'subject': 'tema',
            'send': 'Enviar',
            'saveAsDrafts': 'Guardar como borradores',
            'onlineSources': 'Fuentes en línea',
            'lastMonth': 'El mes pasado',
            'widgets': 'Widgets',
            'listing': 'Listado',
            'paid': 'Pagado',
            'refunded': 'Reintegrado',
            'done': 'Hecho',
            'pending': 'Pendiente',
            'cancelled': 'Cancelado',
            'approve': 'Aprobar',
            'following': 'Siguiendo',
            'follow': 'seguir',
            'graphs&Charts': 'Gráficos y gráficos',
            'open': 'Abierto',
            'bounced': 'Rebotado',
            'spam': 'Correo no deseado',
            'unset': 'Desarmado',
            'bandwidthUse': 'Uso del ancho de banda',
            'dataUse': 'Uso de datos',
            'unsubscribe': 'Darse de baja',
            'profile': 'Perfil',
            'messages': 'Mensajes',
            'support': 'Apoyo',
            'faq(s)': 'Faq (s)',
            'upgradePlains': 'Actualizar llanuras',
            'logOut': 'Cerrar sesión',
            'mail': 'Correo',
            'adminTheme': 'Tema de Admin',
            'wordpressTheme': 'Tema de Wordpress',
            'addToCart': 'Añadir a la cesta',
            'plan': 'Plan',
            'basic': 'BASIC',
            'pro': 'Pro',
            'startToBasic': 'Comience a básico',
            'upgradeToPro': 'Actualizar a Pro',
            'upgradeToAdvance': 'Mejorar A Avanzar',
            'comparePlans': 'Comparar Planes',
            'free': 'Gratis',
            'frequentlyAskedQuestions': 'Frecuentemente Preguntó Preguntas',
            'searchIdeas': 'Buscar Ideas',
            'startDate': 'comienzo Fecha',
            'endDate': 'Fin Fecha',
            'category': 'Categoría',
            'apply': 'Apply',
            'downloadPdfReport': 'Descargar Pdf Report',
            'yesterday': 'Ayer',
            'totalOrders': 'Total de pedidos',
            'totalVisitors': 'Visitantes totales',
            'typeYourQuestions': 'Escriba sus preguntas',
            'username': 'Nombre de usuario',
            'password': 'Contraseña',
            'signIn': 'Registrarse',
            'enterYourPassword': 'Ingresa tu contraseña',
            'alreadyHavingAccountLogin': 'Ya tienes acceso a la cuenta',
            'composeMail': 'Redactar correo',
            'issue': 'Problema',
            'recentChat': 'Charla reciente',
            'previousChat': 'Charla anterior',
            'all': 'Todas',
            'filters': 'Filtros',
            'deleted': 'Eliminado',
            'starred': 'Sembrado de estrellas',
            'frontend': 'Interfaz',
            'backend': 'Backend',
            'api': 'Api',
            'simpleAppBar': 'Barra de aplicaciones simple',
            'recents': 'Recientes',
            'cardLink': 'Enlace de tarjeta',
            'anotherLink': 'Otro enlace',
            'cardSubtitle': 'tarjetaSubtittle',
            'confirmationDialogs': 'Diálogos de confirmación',
            'deletableChip': 'Chip eliminable',
            'customDeleteIconChip': 'Chip de icono de eliminación personalizada',
            'openAlertDialog': 'Diálogo de alerta abierta',
            'openResponsiveDialog': 'Diálogo receptivo abierto',
            'openSimpleDialog': 'Abrir un cuadro de diálogo simple',
            'openFormDialog': 'Abrir el cuadro de diálogo de formulario',
            'follower': 'Seguidor',
            'important': 'Importante',
            'private': 'Privado',
            'openLeft': 'Abierto a la izquierda',
            'openRight': 'Abierto a la derecha',
            'openTop': 'Tapa abierta',
            'openBottom': 'Parte inferior abierta',
            'selectTripDestination': 'Seleccione el destino del viaje',
            'pinnedSubheaderList': 'Lista de subcarpetas fijadas',
            'singleLineItem': 'Artículo de línea única',
            'acceptTerms': 'Aceptar los terminos',
            'optionA': 'Opción A',
            'optionB': 'Opción B',
            'optionC': 'Opción C',
            'optionM': 'Opción M',
            'optionN': 'Opción N',
            'optionO': 'Opción O',
            'customColor': 'Color personalizado',
            'centeredTabs': 'Fichas centradas',
            'multipleTabs': 'Múltiples pestañas',
            'preventScrolledButtons': 'Evitar botones desplazados',
            'browse': 'Vistazo',
            'formValidate': 'Formulario Validar',
            'code': 'Código',
            'company': 'Empresa',
            'price': 'Precio',
            'change': 'Cambio',
            'high': 'Alto',
            'low': 'Bajo',
            'volume': 'Volumen',
            'personalDetails': 'Detalles personales',
            'occupation': 'Ocupación',
            'companyName': 'nombre de empresa',
            'phoneNo': 'Telefono no',
            'city': 'Ciudad',
            'zipCode': 'Código postal',
            'updateProfile': 'Actualización del perfil',
            'reject': 'Rechazar',
            'exportToExcel': 'Exportar a Excel',
            'addNewUser': 'Añadir nuevo usuario',
            'workWeek': 'Semana de trabajo',
            'agenda': 'Agenda',
            'conference': 'Conferencia',
            'dailySales': 'Ventas diarias',
            'today': 'Hoy',
            'campaignPerformance': 'Rendimiento de la campaña',
            'supportRequest': 'Solicitud de soporte',
            'usersList': 'Lista de usuarios',
            'lastWeek': 'La semana pasada',
            'buyMore': 'Comprar más',
            'trafficChannel': 'Canal de tráfico',
            'stockExchange': 'Bolsa de valores',
            'tweets': 'Tweets',
            'ourLocations': 'Nuestras ubicaciones',
            'sales': 'Ventas',
            'to': 'Para',
            'shipTo': 'Enviar a',
            'description': 'Descripción',
            'unitPrice': 'Precio unitario',
            'total': 'Total',
            'note': 'Nota',
            'chipWithAvatar': 'Chip con Avatar',
            'chipWithTextAvatar': 'Chip con texto Avatar',
            'chipWithIconAvatar': 'Chip con el icono Avatar',
            'customClickableChip': 'Chip Clickable personalizado',
            'outlineChip': 'Chip de esquema',
            'disableChip': 'Desactivar Chip',
            'alertDialog': 'Diálogo de alerta',
            'animatedSlideDialogs': 'Diálogos de diapositiva animados',
            'fullScreenDialogs': 'Cuadros de diálogo de pantalla completa',
            'formDialogs': 'Diálogos de formulario',
            'simpleDialogs': 'Cuadros de diálogo simples',
            'responsiveFullScreen': 'Pantalla completa receptiva',
            'primary': 'Director de escuela',
            'social': 'social',
            'user': 'Usuario',
            'admin': 'Administrador',
            'permanentdrawer': 'Cajón permanente',
            'persistentdrawer': 'Cajón persistente',
            'swiches': 'Swiches',
            'horizontalLinearAlternativeLabel': 'Etiqueta alternativa horizontal lineal',
            'horizontalNonLinearAlternativeLabel': 'etiqueta alternativa no lineal horizontal',
            'notifications': 'Notificaciones',
            'basicAlert': 'Alerta básica',
            'successAlert': 'Alerta de éxito',
            'warningAlert': 'Alerta de advertencia',
            'reactAutoSuggest': 'reaccionar automáticamente sugerir',
            'components': 'Componentes',
            'inputAdornments': 'Adorements de entrada',
            'multiSelectList': 'Lista de selección múltiple',
            'contextualColoredTable': 'Tabla de colores Contexuales',
            'updateYourEmailAddress': 'Actualiza tu dirección de correo electrónico',
            'selectADefaultAddress': 'Seleccione una dirección predeterminada',
            'activity': 'Actividad',
            'basicCalendar': 'Calendario básico',
            'culturesCalendar': 'Calendario de Culturas',
            'dragAndDropCalendar': 'arrastrar y soltar calendario',
            'quillEditor': 'Pluma Editor',
            'reactDND': 'Reaccionar DND',
            'dragula': 'Dragula',
            'AcceptorrRejectWithin': 'Aceptar o rechazar dentro',
            'quoteOfTheDay': 'Cita del día',
            'updated10Minago': 'Actualizado hace 10 min',
            'personalSchedule': 'Horario personal',
            'activeUsers': 'Usuarios activos',
            'totalRequest': 'Solicitud total',
            'new': 'Nuevo',
            'ShareWithFriends': '¡Compartir con amigos!',
            'helpToShareText': '¡Ayúdenos a difundir el mundo compartiendo nuestro sitio web con sus amigos y seguidores en las redes sociales!',
            'thisWeek': 'Esta semana',
            'howWouldYouRateUs': '¿Cómo nos calificarías?',
            'booking': 'Reserva',
            'confirmed': 'Confirmado',
            'monthly': 'mensual',
            'weekly': 'semanal',
            'target': 'Objetivo',
            'totalActiveUsers': 'Total de usuarios activos',
            'deadline': 'Fecha tope',
            'team': 'Equipo',
            'projectManagement': 'Gestión de proyectos',
            'latestPost': 'Última publicación',
            'projectTaskManagement': 'Project Task Management',
            'selectProject': 'Seleccionar proyecto',
            'activityBoard': 'Tablero de actividad',
            'checklist': 'Checklist',
            'baseConfig': 'Configuración de base',
            'customControlBar': 'Barra de control personalizado',
            'withDownloadButton': 'Con el botón Descargar',
            'httpLiveStreaming': 'HTTP Live Streaming',
            'keyboardShortcuts': 'Atajos de teclado',
            'preview': 'Avance',
            'croppedImage': 'Imagen recortada',
            'transactionList': 'lista de transacciones',
            'transferReport': 'informe de transferencia',
            'expenseCategory': 'categoría de gastos',
            'upcomingEvents': 'Próximos Eventos',
            'OngoingProjects': 'Proyectos en marcha',
            'ProjectStatus': 'estado del proyecto',
            'LiveChatSupport': 'soporte de chat en vivo'
        },
        'components': {
            'buyNow': 'Compra ahora',
            'alreadyHavingAccountSignIn': 'Ya tienes cuenta Inicia sesión',
            'enterYourPassword': 'Ingresa tu contraseña',
            'unlock': 'desbloquear',
            'enterPasswords': 'Ingrese contraseñas',
            'resetPassword': 'Rescatar contraseña',
            'pageNotfound': 'Página no encontrada',
            'goToHomePage': 'Ir a la página de inicio',
            'sorryServerGoesWrong': 'Lo sentimos Servidor va mal',
            'persistentDrawer': 'Cajón persistente',
            'back': 'Espalda',
            'next': 'Siguiente',
            'completeStep': 'Paso completo',
            'withHtml': 'Con Html',
            'prompt': 'Rápido',
            'withDescription': 'Con descripción',
            'success': 'Éxito',
            'passwordPrompt': 'Indicación de contraseña',
            'warning': 'Advertencia',
            'customIcon': 'Icono personalizado',
            'customStyle': 'Estilo personalizado',
            'basic': 'BASIC',
            'submit': 'Enviar',
            'compose': 'Componer',
            'sendMessage': 'Enviar mensaje',
            'addNewTasks': 'Agregar nuevas tareas',
            'addToCart': 'Añadir a la cesta',
            'payNow': 'Pague ahora',
            'print': 'Impresión',
            'cart': 'Carro',
            'viewCart': 'Ver carro',
            'checkout': 'Revisa',
            'summary': 'Resumen',
            'yesterday': 'Ayer',
            'last7Days': 'últimos 7 días',
            'last1Month': 'Último 1 mes',
            'last6Month': 'Últimos 6 meses',
            'spaceUsed': 'Espacio utilizado',
            'followers': 'Seguidor',
            'trending': 'Tendencia',
            'paid': 'Pagado',
            'refunded': 'Reembolsado',
            'done': 'Hecho',
            'pending': 'Pendiente',
            'cancelled': 'Cancelado',
            'approve': 'Aprobar',
            'week': 'Semana',
            'month': 'Mes',
            'year': 'Año',
            'today': 'Hoy',
            'email': 'Correo electrónico',
            'drafts': 'Borradores',
            'sent': 'Enviado',
            'trash': 'Papelera',
            'all': 'Todos',
            'do': 'Do',
            'title': 'Título',
            'projectName': 'Nombre del proyecto',
            'companyName': 'Nombre de la compañía',
            'openAlert': 'Alerta abierta',
            'slideInAlertDialog': 'Dialogo de diapositivas en dialogo',
            'openFullScreenDialog': 'Abrir cuadros de diálogo de pantalla completa',
            'basicChip': 'Chip básico',
            'clickableChip': 'Chip Clickable',
            'left': 'Izquierda',
            'right': 'Derecha',
            'expansionPanel1': 'Panel de expansión 1',
            'expansionPanel2': 'Panel de expansión 2',
            'generalSetting': 'Configuración general',
            'advancedSettings': 'Configuración avanzada',
            'firstName': 'Nombre',
            'lastName': 'Apellido',
            'occupation': 'Ocupación',
            'phoneNo': 'Teléfono No',
            'address': 'Dirección',
            'city': 'Ciudad',
            'state': 'Estado',
            'zipCode': 'código postal',
            'social Connection': 'conexión social',
            'emailPrefrences': 'Preferencias de correo electrónico',
            'myProfile': 'Mi perfil',
            'product': 'Producto',
            'quantity': 'Cantidad',
            'totalPrice': 'Precio total',
            'removeProduct': 'Eliminar producto',
            'mobileNumber': 'Número de teléfono móvil',
            'address2Optional': 'Dirección 2 (Opcional)',
            'country': 'País',
            'zip': 'Cremallera',
            'saveContinue': 'Guardar Continuar',
            'placeOrder': 'Realizar pedido',
            'payment': 'Pago',
            'billingAddress': 'Dirección de Envio',
            'ShippingAddressText': 'La dirección de envío es la misma que la dirección de facturación.',
            'CartEmptyText': '¡Su cesta está vacía!',
            'NoItemFound': 'No se encontró ningún artículo',
            'goToShop': 'Ir a la tienda',
            'cardNumber': 'Número de tarjeta',
            'expiryDate': 'Fecha de caducidad',
            'cvv': 'CVV',
            'nameOnCard': 'Nombre en la tarjeta',
            'confirmPayment': 'Confirmar pago'
        },
        'compenets': {
            'choose': 'Escoger',
            'username': 'Nombre de usuario',
            'passwords': 'Contraseñas',
            'signIn': 'Registrarse',
            'dontHaveAccountSignUp': 'No tiene registro de cuenta',
            'enterUserName': 'Introduzca su nombre de usuario',
            'enterEmailAddress': 'Introducir la dirección de correo electrónico',
            'confirmPasswords': 'Confirmar contraseñas'
        },
        'themeOptions': {
            'sidebarOverlay': 'Superposición de barra lateral',
            'sidebarBackgroundImages': 'Imágenes de fondo de la barra lateral',
            'sidebarImage': 'Imagen de la barra lateral',
            'miniSidebar': 'Mini barra lateral',
            'boxLayout': 'Diseño de caja',
            'rtlLayout': 'Rtl Layout',
            'darkMode': 'Modo oscuro',
            'appSettings': 'Ajustes de Aplicacion',
            'sidebarLight': 'Ligero',
            'sidebarDark': 'Oscuro',
            'themeColor': 'Color del tema'
        },
        'button': {
            'cancel': 'Cancelar',
            'add': 'Añadir',
            'update': 'Actualizar',
            'reply': 'Respuesta',
            'delete': 'Borrar',
            'yes': 'Sí',
            'viewAll': 'Ver todo',
            'like': 'Me gusta',
            'assignNow': 'Asignar ahora',
            'seeInsights': 'Ver estadísticas',
            'acceptTerms': 'Aceptar términos',
            'reject': 'Reject',
            'addNew': 'Agregar nuevo',
            'goToCampaign': 'Ir a la campaña',
            'viewProfile': 'Ver perfil',
            'sendMessage': 'Enviar mensaje',
            'saveNow': 'Guardar ahora',
            'pen': 'bolígrafo',
            'search': 'Buscar',
            'downloadPdfReport': 'Descargar el informe PDF',
            'primary': 'Principal',
            'secondary': 'Secundario',
            'danger': 'Peligro',
            'info': 'Información',
            'success': 'éxito',
            'warning': 'Advertencia',
            'link': 'Enlace',
            'smallButton': 'Botón pequeño',
            'largeButton': 'Botón grande',
            'blockLevelButton': 'Botón de nivel de bloque',
            'primaryButton': 'Botón primario',
            'button': 'Botón',
            'save': 'Guardar',
            'openMenu': 'Abrir menú',
            'openWithFadeTransition': 'Abrir con Descolorarse Transición',
            'openPopover': 'Abrir Popover',
            'accept': 'Aceptar',
            'click': 'hacer clic',
            'complete': 'Completo',
            'back': 'Atrás',
            'next': 'Siguiente',
            'completeStep': 'Paso completo',
            'error': 'Error',
            'writeNewMessage': 'Escribir nuevo mensaje',
            'saveChanges': 'Guardar cambios',
            'addNewUser': 'Agregar nuevo usuario',
            'more': 'Más',
            'useDefaultImage': 'Usar imagen predeterminada',
            'cropImage': 'Delimitar imagen'
        },
        'hint': {
            'whatAreYouLookingFor': 'Qué estás buscando',
            'searchMailList': 'Buscar lista dpe correo'
        },
        'module': {
            'inbox': 'Bandeja de entrada',
            'drafts': 'Borradores',
            'sent': 'Enviado',
            'trash': 'Papelera',
            'spam': 'Correo no deseado',
            'frontend': 'Interfaz',
            'backend': 'Backend',
            'api': 'Api',
            'issue': 'Problema'
        },
        'documents': {},
        'common': {},
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {},
        'componentes': {
            'popularity': 'Popularidad'
        }
    }
};
